import { FieldTypeEnum } from './field-type-enum'
import { MeteDataRes } from './mete-data-res'
import { TermReq } from './term-req'

export interface QuestionnaireResColumnInterface {
  id: number
  groupId: number
  name: string
  require: boolean
  editable: boolean
  description?: string
  label?: string
  weight?: number
  editableFrontend?: number
  isShowFrontend?: number
  /**
   * 如果是新添加的字段需要传
   */
  type: FieldTypeEnum
  metadata?: MeteDataRes
  options?: TermReq[]
}

export class QuestionnaireResColumn implements QuestionnaireResColumnInterface {
  id: number
  groupId: number
  name: string
  require: boolean
  editable: boolean
  description?: string
  label?: string
  weight?: number
  editableFrontend?: number
  isShowFrontend?: number
  /**
   * 如果是新添加的字段需要传
   */
  type: FieldTypeEnum
  metadata?: MeteDataRes
  options?: TermReq[]

  constructor(props: QuestionnaireResColumnInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      groupId: _groupId,
      name: _name,
      require: _require,
      editable: _editable,
      description: _description,
      label: _label,
      weight: _weight,
      editableFrontend: _editableFrontend,
      isShowFrontend: _isShowFrontend,
      type: _type,
      metadata: _metadata,
      options: _options,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.groupId = _groupId
    this.name = _name
    this.require = _require
    this.editable = _editable
    this.description = _description
    this.label = _label
    this.weight = _weight
    this.editableFrontend = _editableFrontend
    this.isShowFrontend = _isShowFrontend
    this.type = _type
    this.metadata = _metadata ? new MeteDataRes(_metadata) : _metadata
    this.options = _options ? _options.map((i) => new TermReq(i)) : _options
  }
}
